// Algolia pagination starts at 0
import { isMobile } from "./frame";

export function parsePageWithZeroIndex(evPage) {
	const intPage = parseInt(evPage);
	if (isNaN(intPage) || intPage < 1) {
		return 0;
	}
	return intPage - 1;
}

export function parsePage(evPage) {
	const intPage = parseInt(evPage);
	if (isNaN(intPage) || intPage < 0) {
		return 1;
	}
	return intPage;
}

export function defaultHitsPerPage() {
	// TODO: This is a temporary fix to reduce calls to Algolia.
	// if (isMobile()) {
	//   return process.env.DEFAULT_HITS_PER_PAGE_MOBILE || 15;
	// } else {
	return process.env.DEFAULT_HITS_PER_PAGE || 30;
	// }
}
